// Centralised data-testid registry for Yeniçiftlik Köşe Taksi
export const HOME = {
    emergentLink: "emergent-link",
};

export const TAXI = {
    // Floating CTA
    floatingCallBtn: "floating-call-btn",
    // Header
    headerLogo: "header-logo",
    headerCallBtn: "header-call-btn",
    navHero: "nav-hero",
    navServices: "nav-services",
    navAreas: "nav-areas",
    navAbout: "nav-about",
    navLocation: "nav-location",
    navContact: "nav-contact",
    // Hero
    heroCallBtn: "hero-call-btn",
    heroWhatsappBtn: "hero-whatsapp-btn",
    // Services
    serviceCard: "service-card",
    // Areas
    areaChip: "area-chip",
    // Location
    mapEmbed: "map-embed",
    mapOpenBtn: "map-open-btn",
    // Contact
    contactCallBtn: "contact-call-btn",
    // Footer
    footerYear: "footer-year",
};
